/// <amd-module name="Repos/Views/PullRequest/Components/ActivityFeed/ActivityCards/BrokenStateCard" />
import * as React from "react";
import * as Resources from "Repos/Views/PullRequest/Resources";
import { format } from "VSS/Core/Util/String";
import { Components } from "VSS/Platform/Layout";
import { ActivityCardSubtle, IActivityCardSharedProps } from "./ActivityCardSubtle";
import { ActivityShimmer } from "./ActivityShimmer";
import { Icon } from "VSSUI/Icon";
import { Card } from "VSSUI/Card";

export const AutoCompleteCard: React.FunctionComponent<IActivityCardSharedProps> = props => {
    const { isShim } = props;
    if (!isShim) {
        return (
            <Card className="flex-row flex-grow" contentProps={{ contentPadding: false }}>                
                <ActivityCardSubtle createDate={props.thread.publishedDate}>
                    <Icon className={"broken-state-icon"} iconName="Warning" tooltipProps={{ text: Resources.ActivityFeedBrokenStateIconTooltip }} />
                    {format(Resources.ActivityFeedPullRequestEnteredBrokenState, props.thread.comments[0].content)}
                </ActivityCardSubtle>
            </Card>
        );
    }

    return (
        <ActivityCardSubtle createDate={props.thread.publishedDate}>
            <ActivityShimmer />
        </ActivityCardSubtle>
    );
};

Components.add("ms.vss-code-web.broken-state-card", AutoCompleteCard);